module.exports = __webpack_public_path__ + "static/SBbabyshowerinvitations-6c6f62a81c32d287b8efbb96b0654c03.png";